import { render } from "./customDatatable.vue?vue&type=template&id=fb87ac42"
import script from "./customDatatable.vue?vue&type=script&lang=js"
export * from "./customDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__